<div class="splash-modal" [class.splash-modal--shown]="shown">
  <div class="splash-modal__dialog splash-modal__dialog--{{size}}" role="document">
    <!-- <ng-content></ng-content> -->
    <div class="splash-modal__content">
      @if (title || subTitle) {
        <div class="splash-modal__header">
          <button
            (click)="handleClose()"
            type="button"
            class="splash-modal__close"
            aria-label="Close"
            >
            <span aria-hidden="true">&times;</span>
          </button>
          @if (title) {
            <h4>{{ title }}</h4>
          }
          @if (subTitle) {
            <h5>{{ subTitle }}</h5>
          }
        </div>
      }

      <div class="splash-modal__body splash-modal__scroll">
        <ng-content></ng-content>
      </div>

      <div class="splash-modal__footer">
        @if (onCloseText) {
          <app-cmn-button
            type="button"
            variant="secondary"
            buttonClass="close-button"
            (buttonClick)="handleClose()">
            {{ onCloseText }}
          </app-cmn-button>
        }
        @if (onSuccessText) {
          <app-cmn-button
            type="button"
            variant="primary"
            buttonClass="success-button"
            (buttonClick)="handleSuccess()">
            {{ onSuccessText }}
          </app-cmn-button>
        }
        @if (onContinueText) {
          <app-cmn-button
            type="button"
            variant="secondary"
            buttonClass="continue-button"
            (buttonClick)="handleContinue()">
            {{ onContinueText }}
          </app-cmn-button>
        }
        @if (onAcceptText) {
          <app-cmn-button
            type="button"
            variant="primary"
            buttonClass="accept-button"
            (buttonClick)="handleAccept()">
            {{ onAcceptText }}
          </app-cmn-button>
        }
      </div>
    </div>
  </div>
</div>
